/*
 * PDP fitment checker. Decides which state of the ymm-fitment-check snippet to show
 * by comparing the product's fitment metafields (filters.*) against the garage
 * vehicle, and re-renders live when the mini picker checks a vehicle ('ymm:vehicle')
 * or the shopper clicks "Not your car?".
 */
(function () {
  var garage = NewarkYMM.getVehicle;
  // Metafield values arrive JSON-encoded: single-value fields as "Chevrolet",
  // list fields as ["a","b"], missing as null. Normalize all to arrays.
  function parseList(raw) {
    if (!raw) return [];
    try {
      var v = JSON.parse(raw);
      if (v === null || v === undefined || v === '') return [];
      return Array.isArray(v) ? v.map(String) : [String(v)];
    } catch (e) { return []; }
  }
  var label = NewarkYMM.label;
  function yearsRange(years) {
    var nums = years.map(function (y) { return parseInt(y, 10); }).filter(function (n) { return !isNaN(n); });
    if (!nums.length) return '';
    var mn = Math.min.apply(null, nums), mx = Math.max.apply(null, nums);
    return mn === mx ? String(mn) : mn + '–' + mx;
  }

  function init(root) {
    var makes = parseList(root.getAttribute('data-fit-makes'));
    var models = parseList(root.getAttribute('data-fit-models'));
    var years = parseList(root.getAttribute('data-fit-years'));
    var mmy = parseList(root.getAttribute('data-fit-mmy'));
    var apps = parseList(root.getAttribute('data-fit-apps'));
    var ptype = root.getAttribute('data-product-type') || '';
    var hasFitment = mmy.length > 0 || (makes.length > 0 && years.length > 0);
    // "Mercedes-Benz|380SL|1981-1985" -> "1981-1985 Mercedes-Benz 380SL"
    function appPretty(a) {
      var q = a.split('|');
      return q.length === 3 ? q[2] + ' ' + q[0] + ' ' + q[1] : a;
    }

    function show(state) {
      root.querySelectorAll('[data-fit-state]').forEach(function (el) {
        el.hidden = el.getAttribute('data-fit-state') !== state;
      });
    }

    function render() {
      var v = garage();
      var complete = v && v.make && v.model && v.year;

      if (!hasFitment) {
        var lead = root.querySelector('[data-fit-nodata-lead]');
        if (lead) {
          lead.textContent = complete
            ? 'Not sure this fits your ' + label(v) + '?'
            : 'Questions about fit?';
        }
        show('nodata');
        return;
      }

      if (!complete) { show('picker'); return; }

      var fits = NewarkYMM.fits({ mmy: mmy, make: makes, model: models, years: years }, v);
      if (fits) {
        root.querySelector('[data-fit-vehicle]').textContent = label(v);
        show('fit');
      } else {
        root.querySelector('[data-fit-vehicle2]').textContent = label(v);
        root.querySelector('[data-fit-actual]').textContent = apps.length
          ? 'This part fits ' + apps.map(appPretty).join(', ') + '.'
          : 'This part fits ' + yearsRange(years) + ' ' + makes.join('/') + ' ' + models.join('/') + '.';
        var alt = root.querySelector('[data-fit-alt]');
        if (alt) {
          alt.href = NewarkYMM.searchUrl(v, { productType: ptype });
          alt.textContent = 'See parts that fit your ' + label(v) + ' →';
        }
        show('nofit');
      }
    }

    root.querySelectorAll('[data-fit-clear], [data-fit-clear2]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        window.NewarkGarage.clear(); // shared garage API: every surface hears 'ymm:vehicle'
      });
    });

    // Mini picker checked a vehicle (ymm-search.js saved it to the garage already).
    document.addEventListener('ymm:vehicle', render);
    render();
  }

  document.querySelectorAll('[data-ymm-fitment]').forEach(init);
})();
